import { render, staticRenderFns } from "./BenefitsNav.vue?vue&type=template&id=5671a02e&scoped=true"
import script from "./BenefitsNav.vue?vue&type=script&lang=js"
export * from "./BenefitsNav.vue?vue&type=script&lang=js"
import style0 from "./BenefitsNav.vue?vue&type=style&index=0&id=5671a02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671a02e",
  null
  
)

export default component.exports